<template>
    <div class="teams" :style="`height: ${height}`">
        <b-modal no-close-on-backdrop title="Edit Team" class="modal-success" v-model="editTeamDlg" ok-variant="success" :ok-only="true" ok-title="Close" size="lg"
            @ok="onSubmitTeam">
            <b-container fluid>
                <b-card title="Edit your team">
                    <b-form @submit.prevent="onSubmitTeam">
                        <b-container fluid class="dlg">
                            <b-row v-for="p of editPeoples" :key="p.login">
                                <b-col cols="3">
                                    <b-form-group id="input-group-1" label="Job Title / Role" label-for="input-title">
                                        <b-form-input id="input-title" v-model="p.text" type="text" readonly />
                                    </b-form-group>
                                </b-col>
                                <b-col cols="8">
                                    <b-form-group id="input-group-2" label="Name" label-for="input-name">
                                        <b-form-input id="input-name" v-model="p.full" type="text" readonly />
                                    </b-form-group>
                                </b-col>
                                <b-col>
                                    <b-button size="sm" class="trash" variant="danger" @click="deletePeople(p)"><v-icon name="trash" scale="1" /></b-button>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="3">
                                    <b-form-group id="input-group-1" label="Job Title / Role" label-for="input-title">
                                        <b-form-select id=input-title v-model="newRoleId" :options="roles"></b-form-select>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="8">
                                    <b-form-group id="input-group-2" label="Name" label-for="input-name">
                                        <b-form-select id="input-name" v-model="newId" :options="availUsers" />
                                    </b-form-group>
                                </b-col>
                                <b-col>
                                    <b-button size="sm" class="trash" variant="info" @click="addPeople()"><v-icon name="plus" scale="1" /></b-button>
                                </b-col>
                            </b-row>
                        </b-container>
                    </b-form>
                </b-card>
            </b-container>
        </b-modal>
        <b-card :title="marsilli ? 'Marsilli Team' : cTeam">
            <b-container fluid>
                <b-row v-for="t of peoples" :key="t.id">
                    <b-col>
                        <b-card no-body class="overflow-hidden">
                            <b-row no-gutters>
                                <b-col md="3">
                                    <b-card-img src="/images/user.png" alt="User" class="user"></b-card-img>
                                </b-col>
                                <b-col md="9">
                                    <b-card-body :title="t.text">
                                        <b-card-text>
                                            {{ t.name }} {{ t.surname }}<br>
                                            {{ t.email  || t.login }}
                                        </b-card-text>
                                    </b-card-body>
                                </b-col>
                            </b-row>
                        </b-card>
                    </b-col>
                </b-row>
            </b-container>
            <b-button block @click="onEditTeam()">&#x270E;</b-button>
        </b-card>
    </div>
</template>
<script>
import { API } from "@/api.js";

export default {
    name: "Teams",
    components: {
    },
    data: function () {
        return {
            editTeamDlg: false,
            peoples: [],
            editPeoples: [],
            roles: [],
            newRoleId: 0,
            newId: 0,
            availUsers:[],
        }
    },
    props: {
        height: { type: String, default: "calc(100vh - 750px)" },
        marsilli: { type: Boolean, default: false }
    },
    computed: {
        cTeam() {
            return this.$store.getters.marsilli ? "Customer Team" : "Your Team";
        },
        section(){
            return this.$store.getters.section
        },
        machine(){
            return this.$store.getters.machine
        },
    },
    async mounted() {
        // console.log("machine", this.machine)
        this.roles = (await API.getRoles()).map(r => { return { value: r.id, text: r.text } }); 
        await this.updPeoples()
    },
    methods: {
        async updPeoples(){
            let peoples = await API.getTeams(this.machine.codice, this.section)
            this.peoples = peoples.filter(f => f.marsilli==this.marsilli);
            console.log("peoples", this.peoples)
        },
        async deletePeople(p){
            console.log("deletePeople", p)
            await API.piDeleteTeamMember(this.machine.codice, p.id, this.section)
            let peoples = await API.getTeams(this.machine.codice, this.section)
            this.peoples = peoples.filter(f => f.marsilli==this.marsilli);
            await this.onEditTeam()
        },
        async addPeople(){
            console.log("addPeople", this.newRoleId, this.newId)
            if(this.newRoleId==0 || this.newId==0) return
            await API.piAddTeamMember(this.machine.codice, this.newId, this.newRoleId, this.section)
            this.newRoleId = 0
            this.newId = 0
            await this.updPeoples()
            await this.onEditTeam()
        },
        async onEditTeam() {
            console.log("onEditTeam")
            // copio i dati nell'altro array
            this.editPeoples = JSON.parse(JSON.stringify(this.peoples)).map(p => {
                p.full = this.userName(p)
                return p;
            });
            let noids = this.peoples.map(p => p.id)
            this.availUsers = (await API.getAvailUsers(this.machine.codice, this.marsilli ? true : null)).filter(f => !noids.includes(f.id)).map(p => ({
                value: p.id,
                text: this.userName(p)
            }));
            this.editTeamDlg = true;
        },
        async onSubmitTeam() {
            console.log("onSubmitTeam")
            // if (this.editTeamDlg) {
            //     await API.prodEditTeam(this.currTeam.id, this.formTeam.title, this.formTeam.people.map(p => p.value))
            // } else {
            //     await API.prodAddTeam(this.machine.codice, this.formTeam.title, this.formTeam.people.map(p => p.value))
            // }
            // let peoples = await API.getTeams(this.machine.codice, this.section)
            // this.peoples = peoples.filter(f => f.marsilli==this.marsilli);
        },
        onMSelect(items) {
            console.log("ITEMS", items);
            this.formTeam.people = items;
        },
    }
}

</script>
<style scoped>
img.user {
    padding-top: 15px;
    width: 80px;
}
div.teams button {
    background-color: #9a240d !important;
    border-color: #9a240d !important;
    margin-bottom: 10px;
}

div.teams button:hover {
    box-shadow: 0 0 0 .2rem rgba(154, 36, 13, 0.5) !important;
}

div.teams button:active {
    box-shadow: 0 0 0 .2rem rgba(154, 36, 13, 0.5) !important;
}
div.dlg button.trash {
    background-color: white !important;
    border-color: white !important;
    fill: #9a240d !important;
    margin-bottom: 10px;
    padding-top: 10px;
}

div.dlg button:hover {
    box-shadow: 0 0 0 .2rem rgba(255, 255, 255, 0) !important;
}

div.dlg button:focus {
    box-shadow: 0 0 0 .2rem rgba(255, 255, 255, 0) !important;
}

div.dlg button:active {
    box-shadow: 0 0 0 .2rem rgba(255, 255, 255, 0) !important;   
}

div.card button {
    width: 24px;
    height: 24px;
    padding: 0px;
    /* padding-bottom: 0px; */
    position: absolute;
    top: 25px;
    right: 20px;
}
</style>
